import React from 'react';
import { EOrderTab } from '../../../../../store/ducks/long-steel-orders/types';
import { Icon } from '@gerdau/hefesto/Icon';

import {
  SalesOrderActionButtonsContainer,
  SalesOrderActionButtonsWrapper,
  SalesOrderContent,
  SalesOrderDetail,
  SalesOrderDetailGrid,
  SalesOrderItemContainer,
  SalesOrderItemDetail,
  SalesOrderItemHeader,
  SalesOrderItemText,
  SalesOrderItemWrapper,
  SalesOrderResumeWrapper,
  SalesOrderContentWrapper,
  SalesOrderTextTooltipWrapper,
  SalesOrderResumeWrapperContent,
  MessageValueCanChange
} from './styles';
import { Button } from '@gerdau/hefesto';
import { DetailCard } from '../DetailCard';
import { ContentToggle } from '../styles';
import { TooltipDetail } from '../TooltipDetail';
import {
  EOrderType,
  SalesOrderItemTable
} from '../../../../../store/ducks/new-long-steel-orders/types';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  downloadOrderItems,
  validationUpdateItems
} from '../../../../../store/ducks/new-long-steel-orders/actions';
import { useHistory, useLocation } from 'react-router-dom';
import {
  formatCurrencyValue,
  isUnavailable,
  toNumberOrZero
} from '../../../../../store/ducks/new-long-steel-orders';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { ApplicationState } from '../../../../../store';
import { ProgressVolumeBar } from '../../ProgressVolumeBar';

interface Props {
  data: SalesOrderItemTable;
}

const SalesOrderResume = ({ data }: { data: SalesOrderItemTable }) => {
  return (
    <SalesOrderResumeWrapper>
      <DetailCard
        {...{
          title: 'Status do pedido',
          withoutSubtitle: true
        }}
      >
        <ProgressVolumeBar
          billed={{
            quantity: toNumberOrZero(
              data?.billing?.reduce(
                (itmAcc, itmItem) =>
                  itmAcc + (Number(itmItem.billedConversionQuantity) || 0),
                0
              )
            ),

            measureUnit: 'T'
          }}
          delivery={{
            quantity: Number(data.quantities.deliveryConversionQuantity || 0),
            measureUnit: 'T'
          }}
          pending={{
            quantity: Number(data.quantities.pendingConversionQuantity || 0),
            measureUnit: 'T'
          }}
          requested={{
            quantity: Number(data.quantities.requestedConversionQuantity || 0),
            measureUnit: 'T'
          }}
          shipment={{
            quantity: Number(data.quantities.shipmentConversionQuantity || 0),
            measureUnit: 'T'
          }}
        />
      </DetailCard>

      {!!data?.futureDeliveries?.[0]?.estimatedDeliveryDate && (
        <DetailCard
          {...{
            title: 'Próxima data estimada',
            subtitle: `${parseFloat(
              data?.futureDeliveries?.[0]?.estimatedDeliveryQuantity || ''
            ).toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} ${data?.futureDeliveries?.[0]?.estimatedDeliveryMeasureUnit?.toLocaleUpperCase()} - ${
              data?.futureDeliveries?.[0]?.estimatedDeliveryDate
            }`
          }}
        />
      )}
    </SalesOrderResumeWrapper>
  );
};

interface SalesOrderItemProps {
  data: SalesOrderItemTable;
  hidden: boolean;
}

const SalesOrderItemContent = ({ data, hidden }: SalesOrderItemProps) => {
  if (hidden) {
    return null;
  }

  const history = useHistory();
  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const handleCancel = () => {
    dispatch(
      validationUpdateItems({
        itemsSelected: [data],
        typeAction: 'cancel'
      })
    );

    dispatch(
      sendTagging({
        event: 'ordem_vd_clicks',
        click: 'solicitar_cancelamento',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const handleUpdate = () => {
    dispatch(
      validationUpdateItems({
        itemsSelected: [data],
        typeAction: 'update'
      })
    );

    dispatch(
      sendTagging({
        event: 'ordem_vd_clicks',
        click: 'solicitar_alteracoes',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const handleDownload = () => {
    dispatch(downloadOrderItems({ downloadsItemsSelected: [data] }));
    history.push(`${pathname}?downloads`);

    dispatch(
      sendTagging({
        event: 'ordem_vd_clicks',
        click: 'baixar_documentos',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.startDate
        ).format('DD/MM/YYYY'),
        data_fim: moment(
          ordersState[ordersState.tableType || EOrderTab.OPEN]
            .initialInputValues.endDate
        ).format('DD/MM/YYYY')
      })
    );
  };

  const productsDetailTop = [
    {
      title: 'Identificação do pedido',
      value: data.customerOrder
    },
    {
      title: 'Número da OV',
      value: data.salesOrder
    },
    {
      title: 'Data desejada',
      value: data.requestedDateTable ?? ' - '
    },
    {
      title: 'Quantidade solicitada',
      value: data.totalQuantityRequested,
      tooltip: 'Solicitado é a quantidade solicitada.'
    },
    {
      title: 'Saldo',
      value: data.totalQuantityPending,
      tooltip: 'O saldo é o quanto resta do seu pedido a ser faturado.'
    }
  ];

  const productsDetailBottom = [
    {
      title: 'Confirmado',
      value: data.totalQuantityConfirmed,
      tooltip: 'Confirmado é a quantidade que foi confirmada.'
    },
    {
      title: 'Em remessa',
      value: data.totalQuantityDelivery,
      tooltip:
        'Em remessa significa que a geração da remessa de alguma quantidade está em andamento.'
    },
    {
      title: 'Em carregamento',
      value: data.totalQuantityShipment,
      tooltip:
        'Em carregamento significa que o transporte de alguma quantidade está em processo de contratação'
    },
    {
      title: 'Faturado',
      value: data.totalQuantityBilled,
      tooltip:
        'Faturado é o quanto do seu pedido gerou nota fiscal e foi para a logística.'
    }
  ];

  const deliveryDetail =
    data?.futureDeliveries?.map((item, index) => ({
      title: `${index + 1}ª data estimada para ${item?.estimatedDeliveryDate}`,
      value: `${parseFloat(
        item?.estimatedDeliveryQuantity || ''
      ).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} ${item?.estimatedDeliveryMeasureUnit}`
    })) || [];

  const paymentDetailTop = [
    {
      title: 'Condição de pagamento',
      value:
        data.conditions.paymentTermsDescription ||
        (data.billing &&
          data.billing.length > 0 &&
          data.billing[0]?.paymentTermsDescription) ||
        'Indisponível'
    },
    ...(data.fiscalBenefit === 'X'
      ? [
          {
            title: 'Benefício fiscal',
            value: 'Sim'
          }
        ]
      : [])
  ];
  const isFullyBilled =
    Number(data.quantities?.pendingConversionQuantity || 0) <= 0 &&
    Number(data.quantities?.billedConversionQuantity || 0) > 0;

  const totalPriceWithTaxes = isFullyBilled
    ? data.conditions.invoiceTotalValueWithTaxes
    : data.conditions.totalValueWithTaxes;

  const totalPriceWithoutTaxes = isFullyBilled
    ? data.conditions.invoiceTotalValueWithoutTaxes
    : data.conditions.totalValueWithoutTaxes;

  const paymentDetailBottom = [
    ...(isUnavailable(totalPriceWithTaxes)
      ? []
      : [
          {
            title: 'Preço total',
            value: formatCurrencyValue(totalPriceWithTaxes)
          }
        ]),
    ...(isUnavailable(totalPriceWithoutTaxes)
      ? []
      : [
          {
            title: 'Preço total s/ impostos',
            value: formatCurrencyValue(totalPriceWithoutTaxes)
          }
        ]),
    ...(isUnavailable(data.conditions.icms)
      ? []
      : [
          {
            title: 'ICMS',
            value: formatCurrencyValue(data.conditions.icms)
          }
        ]),
    ...(isUnavailable(data.conditions.itemPis)
      ? []
      : [
          {
            title: 'PIS',
            value: formatCurrencyValue(data.conditions.itemPis)
          }
        ]),
    ...(isUnavailable(data.conditions.itemCofins)
      ? []
      : [
          {
            title: 'COFINS',
            value: formatCurrencyValue(data.conditions.itemCofins)
          }
        ]),
    ...(isUnavailable(data.conditions.ipi)
      ? []
      : [
          {
            title: 'IPI',
            value: formatCurrencyValue(data.conditions.ipi)
          }
        ]),
    ...(isUnavailable(data.conditions.st)
      ? []
      : [
          {
            title: 'ST',
            value: formatCurrencyValue(data.conditions.st)
          }
        ])
    // {
    //   title: 'FCP',
    //   value: 'R$ 1.234.567,89'
    // },
    // {
    //   title: 'DIFAL',
    //   value: 'R$ 1.234.567,89'
    // }
  ];
  const flatSteelBottom = [
    {
      title: 'Aciaria',
      value: data?.meltShop || '-'
    },
    {
      title: 'Laminação',
      value: data?.rollingMill || '-'
    },
    {
      title: 'LA',
      value: data?.rollingFinish || '-'
    },
    {
      title: 'Acabamento',
      value: data?.finish || '-'
    },
    {
      title: 'Estoque Usina',
      value: data?.stockMill || '-'
    },
    {
      title: 'Em transferência',
      value: data?.transit || '-'
    },
    {
      title: 'Estoque entre-posto',
      value: data?.stockWarehouse || '-'
    }
  ];

  const canDownloadAnyDocument =
    data?.billing?.some((item) => item.canDownloadQC) ||
    data?.billing?.some((item) => item.canDownloadNF) ||
    data?.billing?.some((item) => !!item.invoiceZvoi);

  return (
    <SalesOrderContentWrapper>
      <SalesOrderContent>
        <SalesOrderDetail>
          <SalesOrderItemText bold>Detalhes do produto</SalesOrderItemText>
          <SalesOrderDetailGrid>
            {productsDetailTop.map((item) => (
              <React.Fragment key={item.title}>
                <SalesOrderTextTooltipWrapper>
                  <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                  <TooltipDetail {...{ titleTooltip: item.tooltip }} />
                </SalesOrderTextTooltipWrapper>
                <SalesOrderItemText small alignRight>
                  {item.value}
                </SalesOrderItemText>
              </React.Fragment>
            ))}
          </SalesOrderDetailGrid>
          <SalesOrderDetailGrid>
            {productsDetailBottom.map((item) => (
              <React.Fragment key={item.title}>
                <SalesOrderTextTooltipWrapper>
                  <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                  <TooltipDetail {...{ titleTooltip: item.tooltip }} />
                </SalesOrderTextTooltipWrapper>
                <SalesOrderItemText small alignRight>
                  {item.value}
                </SalesOrderItemText>
              </React.Fragment>
            ))}
          </SalesOrderDetailGrid>
          {data.orderType === EOrderType.PLANOS && (
            <SalesOrderDetailGrid>
              {flatSteelBottom.map((item) => (
                <React.Fragment key={item.title}>
                  <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                  <SalesOrderItemText small alignRight>
                    {item.value}
                  </SalesOrderItemText>
                </React.Fragment>
              ))}
            </SalesOrderDetailGrid>
          )}
        </SalesOrderDetail>
        <SalesOrderDetail>
          {deliveryDetail.length > 0 && (
            <>
              <SalesOrderItemText bold>Entrega</SalesOrderItemText>
              <SalesOrderDetailGrid withGap>
                {deliveryDetail.map((item) => (
                  <React.Fragment key={item.title}>
                    <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                    <SalesOrderItemText small alignRight>
                      {item.value}
                    </SalesOrderItemText>
                  </React.Fragment>
                ))}
              </SalesOrderDetailGrid>
            </>
          )}
        </SalesOrderDetail>
        <SalesOrderDetail>
          <SalesOrderItemText bold>Pagamento</SalesOrderItemText>
          {data.futureDeliveriesTable === 'Aguardando confirmação' && (
            <MessageValueCanChange>
              Os valores podem sofrer alterações durante a confirmação do
              pedido.
            </MessageValueCanChange>
          )}
          <SalesOrderDetailGrid>
            {paymentDetailTop.map((item) => (
              <React.Fragment key={item.title}>
                <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                <SalesOrderItemText small alignRight>
                  {item.value}
                </SalesOrderItemText>
              </React.Fragment>
            ))}
          </SalesOrderDetailGrid>
          <SalesOrderDetailGrid>
            {paymentDetailBottom.map((item) => (
              <React.Fragment key={item.title}>
                <SalesOrderItemText small>{item.title}</SalesOrderItemText>
                <SalesOrderItemText small alignRight>
                  {item.value}
                </SalesOrderItemText>
              </React.Fragment>
            ))}
          </SalesOrderDetailGrid>
        </SalesOrderDetail>
      </SalesOrderContent>
      <SalesOrderActionButtonsContainer>
        <Button
          name="sales-order-cancel-button"
          onClick={handleCancel}
          variant="danger"
          disabled={data.orderType !== EOrderType.LONGOS}
        >
          Solicitar cancelamento
        </Button>
        <SalesOrderActionButtonsWrapper>
          <Button
            onClick={handleUpdate}
            name="sales-order-change-button"
            variant="secondary"
            disabled={data.orderType !== EOrderType.LONGOS}
          >
            Solicitar alterações
          </Button>
          <Button
            name="sales-order-download-button"
            variant="secondary"
            onClick={handleDownload}
            disabled={!canDownloadAnyDocument}
          >
            Baixar documentos
          </Button>
        </SalesOrderActionButtonsWrapper>
      </SalesOrderActionButtonsContainer>
    </SalesOrderContentWrapper>
  );
};

export const SalesOrder = ({ data }: Props) => {
  const [showContent, setShowContent] = React.useState(false);

  const dispatch = useDispatch();
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const handleToggleContent = () => {
    if (showContent === false) {
      dispatch(
        sendTagging({
          event: `pedido_ordem${data.salesOrder}`,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.startDate
          ).format('DD/MM/YYYY'),
          data_fim: moment(
            ordersState[ordersState.tableType || EOrderTab.OPEN]
              .initialInputValues.endDate
          ).format('DD/MM/YYYY')
        })
      );
    }

    setShowContent((prev) => !prev);
  };

  return (
    <SalesOrderItemContainer>
      <SalesOrderItemHeader resume={!showContent}>
        <SalesOrderItemDetail>
          <SalesOrderItemWrapper>
            <SalesOrderItemText bold>{data.sku}</SalesOrderItemText>
            <SalesOrderItemText withEllipse>
              {data.materialDescription}
            </SalesOrderItemText>
          </SalesOrderItemWrapper>
        </SalesOrderItemDetail>
        <SalesOrderResumeWrapperContent>
          <SalesOrderResume data={data} />
          <div style={{ display: 'flex' }}>
            <DetailCard
              {...{
                title: 'Status do produto',
                futureDeliveriesTable: data.futureDeliveriesTable,
                withTag: true,
                hasAnyBiiledQuantity:
                  toNumberOrZero(
                    data?.billing?.reduce(
                      (itmAcc, itmItem) =>
                        itmAcc +
                        (Number(itmItem.billedConversionQuantity) || 0),
                      0
                    )
                  ) > 0 || Number(data?.quantities?.billedQuantity || 0) > 0
              }}
            />
            <ContentToggle onClick={handleToggleContent}>
              <Icon
                option={showContent ? 'ChevronUp' : 'ChevronDown'}
                size="sm"
                variant="primary"
              />
            </ContentToggle>
          </div>
        </SalesOrderResumeWrapperContent>
      </SalesOrderItemHeader>
      <SalesOrderItemContent data={data} hidden={!showContent} />
    </SalesOrderItemContainer>
  );
};
